import { createLayoutApp } from "../layout/createLayoutApp";
import AgencyTabComponent from "../hotelDetails/agency/AgencyTabComponent.vue";

const hostEl = document.getElementById("hotel-content");
const mountEl = document.getElementById("hotelDescriptionAgency");
if (hostEl && mountEl) {
  const raw = hostEl.getAttribute("data-model");
  const viewModel = raw ? JSON.parse(raw) : null;
  const isPrintMode = hostEl.getAttribute("data-is-print-mode") === "true";

  const app = createLayoutApp(AgencyTabComponent, {
    viewModel,
    isPrintMode,
  });
  app.config.globalProperties.$mobile = false;
  app.mount(mountEl);
}